import DashboardShell from "@/components/nav/DashboardShell";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useSearchParams, Link } from "react-router-dom";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("unknown"); return; }
    let tries = 0;
    const poll = async () => {
      tries++;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (tries < 10) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [params]);

  return (
    <DashboardShell>
      <div className="max-w-xl">
        {status === "checking" && <div className="flex items-center gap-3 text-smoke"><Loader2 className="animate-spin" size={18} /> Confirming your payment…</div>}
        {status === "paid" && (<>
          <CheckCircle2 className="text-gold" size={32} />
          <h1 className="brand-headline text-5xl mt-4">Payment confirmed.</h1>
          <p className="text-smoke mt-4">Your plan is active. Your employees are already working.</p>
          <Link to="/dashboard" className="btn-gold mt-8 inline-flex">Open dashboard</Link>
        </>)}
        {status === "pending" && <div className="text-smoke">Still processing… refresh in a minute.</div>}
        {status === "error" && <div className="text-red-400">Something went wrong. Please contact support.</div>}
      </div>
    </DashboardShell>
  );
}

export function PaymentCancel() {
  return (
    <DashboardShell>
      <div className="max-w-xl">
        <XCircle className="text-smoke" size={32} />
        <h1 className="brand-headline text-5xl mt-4">Payment cancelled.</h1>
        <p className="text-smoke mt-4">No charge was made. You can try again anytime.</p>
        <Link to="/billing" className="btn-gold mt-8 inline-flex">Back to billing</Link>
      </div>
    </DashboardShell>
  );
}
